const router = [
  {
    path: '/diario-escolar',
    name: 'diario-escolar',
    component: () => import('@/views/diario-escolar/TurmasProfessor'),
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'diarioescolar',
      tagTelaFuncao: 'read',
      breadCrumb: 'Notas, Conceitos, Frequência, Parecer e Perfil',
    },
  },
  {
    path: '/frequencia-mensal',
    name: 'frequencia-mensal',
    component: () => import('@/views/diario-escolar/aulas-frequencia/FrequenciaMensal.2'),
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'frequenciamensal',
      tagTelaFuncao: 'read',
      breadCrumb: 'Registro Frequência Mensal',
      breadCrumbDisabled: true,
    },
  },
  {
    path: '/frequencia-mensal-aee-acp',
    name: 'frequencia-mensal-aee-acp',
    component: () => import('@/views/diario-escolar/aulas-frequencia/FrequenciaMensalAEEouACP'),
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'freqmensalaeeouacp',
      tagTelaFuncao: 'read',
      breadCrumb: 'Registro Frequência Mensal - AEE ou Acompanhamento Pedagógico',
      breadCrumbDisabled: true,
    },
  },
  {
    name: 'registro-notificacao',
    path: '/registro-notificacao',
    props: true,
    meta: {
      tagTela: 'registronotificacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Registro de Notificação',
      hasProgress: true,
    },
    component: () => import('@/views/notificacao/RegistroNotificacao.vue'),
  },
  {
    name: 'registro-notificacao-cadastro',
    path: '/registro-notificacao/novo',
    component: () => import('@/views/notificacao/RegistroNotificacaoCadastro.vue'),
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'registronotificacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Nova Notificação'
    },
  },
  {
    path: '/registro-notificacao/:id',
    props: true,
    meta: {
      tagTela: 'registronotificacao',
      tagTelaFuncao: 'read',
      hasProgress: true,
      breadCrumb: 'Alterar Notificação',
    },
    component: () => import('@/views/notificacao/RegistroNotificacaoCadastro.vue'),
  },
  {
    path: '/calendario-escolar',
    name: 'calendarioescolar',
    meta: {
      allowed: true,
      breadCrumb: 'Calendário Escolar',
    },
    component: () => import('@/views/CalendarioEscolar.vue'),
  },
  {
    path: '/diario-escolar/regente/:ano?',
    name: 'diario-escolar-regente',
    component: () => import('@/views/diario-escolar/AulasRegente'),
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'diarioescolar',
      tagTelaFuncao: 'read',
      breadCrumbDisabled: true,
      breadCrumb: 'Atalho para Aulas/Frequência',
    },
  },
  {
    path: '/diario-escolar/aulas',
    component: () => import('@/views/diario-escolar/aulas-frequencia/AulasFrequencia'),
    props: true,
    children: [
      {
        path: '',
        name: 'diario-escolar-aulas',
        component: () => import('@/views/diario-escolar/aulas-frequencia/Aulas'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Listagem de Aulas',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/aula/:id?',
        name: 'diario-escolar-aula',
        component: () => import('@/views/diario-escolar/aulas-frequencia/AulaCadastro'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Cadastro de Aula',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/aula/:id?',
        name: 'diario-escolar-aula-aee-acp',
        component: () => import('@/views/diario-escolar/aulas-frequencia/AulaAEEouACPCadastro'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Cadastro de Aula',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/aulas/frequencia',
        name: 'diario-escolar-aulas-frequencia',
        component: () => import('@/views/diario-escolar/aulas-frequencia/Frequencia'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Frequência',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/aulas/frequencia',
        name: 'diario-escolar-aulas-frequencia-aee-acp',
        component: () => import('@/views/diario-escolar/aulas-frequencia/FrequenciaAEEouACP'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Frequência',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/regente/:ano/frequencia',
        name: 'diario-escolar-regente-frequencia',
        component: () => import('@/views/diario-escolar/aulas-frequencia/Frequencia'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Frequência',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/aulas/frequencia-mensal',
        name: 'diario-escolar-aulas-frequencia-mensal',
        component: () => import('@/views/diario-escolar/aulas-frequencia/FrequenciaMensal'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Frequência Mensal',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/copiar-aulas',
        name: 'diario-escolar-copiar-aulas',
        component: () => import('@/views/diario-escolar/aulas-frequencia/CopiarAulas'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Copiar Aulas',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/lancar-notas',
        name: 'diario-escolar-lancar-notas',
        component: () => import('@/views/diario-escolar/LancarNotas'),
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Lançar Notas',
          breadCrumbDisabled: true,
        },
        props: true,
      },
      {
        path: '/diario-escolar/lancar-conceito',
        name: 'diario-escolar-lancar-conceito',
        component: () => import('@/views/diario-escolar/LancarConceito'),
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Lançar Conceito',
          breadCrumbDisabled: true,
        },
        props: true,
      },
      {
        path: '/diario-escolar/totalizador-nota',
        name: 'diario-escolar-totalizador-nota',
        component: () => import('@/views/diario-escolar/TotalizadorNota'),
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Totalizador Nota/Frequência',
          breadCrumbDisabled: true,
        },
        props: true,
      },
      {
        path: '/diario-escolar/perfil-da-turma',
        name: 'diario-escolar-perfil-turma',
        component: () => import('@/views/diario-escolar/PerfilTurma'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Perfil Turma',
        },
      },
      {
        path: '/diario-escolar/ausencia/:ano?',
        name: 'diario-escolar-ausencia',
        component: () => import('@/views/diario-escolar/GraficoAusencia'),
        props: true,
        meta: {
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Alunos com Ausência Consecutivas',
        },
      },
      {
        path: '/diario-escolar/parecer-descritivo',
        name: 'diario-escolar-parecer-descritivo',
        component: () => import('@/views/diario-escolar/parecer-descritivo/AlunosPerecer'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Parecer Descritivo',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/parecer-descritivo/aluno',
        name: 'diario-escolar-parecer-descritivo-aluno',
        component: () => import('@/views/diario-escolar/parecer-descritivo/ParecerCadastro'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Parecer Descritivo - Aluno',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/parecer-descritivo/aluno-aee-acp',
        name: 'diario-escolar-parecer-descritivo-aluno-aee-acp',
        component: () => import('@/views/diario-escolar/parecer-descritivo/ParecerAEEACPCadastro'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Parecer Circunstanciado - Aluno',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/parecer-descritivo-aee-acp',
        name: 'diario-escolar-parecer-descritivo-aee-acp',
        component: () => import('@/views/diario-escolar/parecer-descritivo/AlunosParecerAEEouACP'),
        props: true,
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Parecer Circunstanciado - Aluno',
          breadCrumbDisabled: true,
        },
      },
      {
        path: '/diario-escolar/cancelar-diario',
        name: 'diario-escolar-cancelar-diario',
        component: () => import('@/views/diario-escolar/CancelarDiario'),
        meta: {
          hasProgress: true,
          tagTela: 'diarioescolar',
          tagTelaFuncao: 'read',
          breadCrumb: 'Cancelar Diário',
          breadCrumbDisabled: true,
        },
        props: true,
      },
    ],
  },
  {
    path: '/demonstrativo-frequencia',
    component: () => import('@/views/DemonstrativoFrequencia'),
    meta: {
      tagTela: 'demonstfrequencia',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo Frequência',
    },
  },
  {
    path: '/demonstrativo-frequencia-dia',
    component: () => import('@/views/DemonstrativoFrequenciaDia'),
    meta: {
      tagTela: 'demonstFreqDia',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo Frequência por Dia',
    },
  },
  {
    path: '/demonstrativo-notas',
    component: () => import('@/views/DemonstrativoNotas'),
    meta: {
      tagTela: 'demonstnotas',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo de Notas',
    },
  },
  {
    path: '/demonstrativo-conteudo-lecionado',
    component: () => import('@/views/DemostrativoConteudoLecionado'),
    meta: {
      tagTela: 'democonteudolecio',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo de Conteúdo Lecionado',
    },
  },
  {
    path: '/demonstrativo-notas-frequencia',
    component: () => import('@/views/DemonstrativoNotasFrequencia'),
    meta: {
      tagTela: 'demonotasfrequencia',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo de Notas com Frequência',
    },
  },
  {
    path: '/relatorio-parecer-descritivo',
    component: () => import('@/views/RelatorioParecerDescritivo'),
    meta: {
      tagTela: 'relparecerdescritivo',
      tagTelaFuncao: 'read',
      breadCrumb: 'Relatório Parecer Descritivo/Circunstanciado',
    },
  },
  {
    path: '/relatorio-perfil-turma',
    component: () => import('@/views/RelatorioPerfilTurma'),
    meta: {
      tagTela: 'relperfilturma',
      tagTelaFuncao: 'read',
      breadCrumb: 'Relatório Perfil da Turma',
    },
  },
  {
    path: '/demonstrativo-conceitos',
    component: () => import('@/views/DemonstrativoConceito'),
    meta: {
      tagTela: 'democonceito',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo de Conceitos',
    },
  },
  {
    path: '/demonstrativo-conceitos-frequencia',
    component: () => import('@/views/DemonstrativoConceitoFrequencia'),
    meta: {
      tagTela: 'democonceitofrequen',
      tagTelaFuncao: 'read',
      breadCrumb: 'Demonstrativo de Conceitos/Frequência',
    },
  },
  {
    path: '/aulas-ministradas-exigidas',
    component: () => import('@/views/AulasMinistradasExigidas'),
    meta: {
      tagTela: 'aulas-ministras',
      tagTelaFuncao: 'read',
      breadCrumb: 'Aulas Ministradas x Exigidas',
    },
  },
  {
    path: '/alunos-conta-google',
    component: () => import('@/views/AlunosContaGoogle.vue'),
    meta: {
      tagTela: 'alunos-google',
      tagTelaFuncao: 'read',
      breadCrumb: 'Alunos - Conta Gooogle',
    },
  },
  {
    path: '/relatorio-notificacoes',
    component: () => import('@/views/RelatorioNotificacoes'),
    meta: {
      tagTela: 'relatorio-notificaco',
      tagTelaFuncao: 'read',
      breadCrumb: 'Relatório de Notificações (Coordenador X Professor)',
    },
  },
];

export default router;
